import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import "../../../View.css";
import "../../../Grid.css";
import "../../../Form.css";
import "../../../App.css";
import "./Provider.css";
import SearchView from "../../../widgets/SearchView";
import OnlineProviderApprovalSearchForm from './OnlineProviderApprovalSearchForm';
import { ViewContainer } from "../../../View.jsx";
import ViewUtils from '../../../ViewUtils';
import withMenuPermission from "../../../widgets/withMenuPermission";


const utils = new ViewUtils();

const headCells = [
    { id: 'LegalName', numeric: false, disablePadding: true, label: 'Legal Name' },
    { id: 'TradeName', numeric: false, disablePadding: true, label: 'Trade Name' },
    { id: 'SDLNumber', numeric: false, disablePadding: true, label: 'SDL Number' },
    { id: 'dateofsubmission', numeric: false, disablePadding: true, label: 'Date of Submission' },
    { id: 'typeofsubmission', numeric: false, disablePadding: true, label: 'Type of Submission' },
    { id: 'status', numeric: false, disablePadding: true, label: 'Status' }
];

const filterParameters = [
    { dataField: "LegalName", text: "LegalName" },
    { dataField: "TradeName", text: "TradeName" },
    { dataField: "SDLNumber", text: "SDLNumber" }
]

class OnlineProviderApprovalSearch extends Component {

    constructor(props) {
        super(props)

        this.searchParameters = this.searchParameters = !utils.isNull(this.props.programmeId) ?

            [
                { Name: "ID", Value: this.props.programmeId },
                { Name: "LegalName", Value: "" },
                { Name: "TradeName", Value: "" },
                { Name: "SDLNumber", Value: "" }
            ]
            :

            [
                { Name: "LegalName", Value: "" },
                { Name: "TradeName", Value: "" },
                { Name: "SDLNumber", Value: "" }
            ]

        if (!utils.isNull(this.props.programmeId)) {
            this.state = {
                model: {
                    LegalName: "",
                    TradeName: "",
                    SDLNumber: "",
                    ID: this.props.programmeId,
                },
                keyUpSwitch: false,
                selectedProvider: null
            };
        }
        else {
            this.state = {
                model: {
                    LegalName: "",
                    TradeName: "",
                    SDLNumber: ""
                },
                keyUpSwitch: false,
                selectedProvider: null
            };
        }

        this.toolbarConfig = {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'edit', label: '', tooltip: 'Edit', icon: 'EditIcon', disabled: true, visible: this.props.menuPermissionItem.Edit },
                        { id: "delete", label: "", tooltip: "Remove Provider", icon: "DeleteIcon", disabled: true, visible: this.props.menuPermissionItem.Delete }
                    ]
                }
            ]
        };
    }

    onkeyup(e) {
        if (e.charCode == 13) {
            this.setState({ keyUpSwitch: !this.state.keyUpSwitch })
        }
    }

    handleSelection = (selection) => {
        if (selection !== null && selection.length !== 0) {
            this.setState({ selectedProvider: selection })
        } else {
            this.setState({ selectedProvider: null })
        }
    }

    handleToolbarButtonClick = (buttonId) => {
       
    }

    render() {
        return (
            <ViewContainer title="">
                <SearchView headCells={headCells} dataUrl={!utils.isNull(this.props.dataUrl) ? this.props.dataUrl : "api/sims/OnlineProviderApproval/GetProviderApplications"}
                    entityViewPath='/providerapproval' model={this.state.model}
                    toolbarConfig={this.toolbarConfig} searchParameters={this.searchParameters}
                    filterParameters={filterParameters}
                    mode={this.props.mode}
                    title='Provider Approval Dashboard' 
                    multiSelect={this.props.multiSelect}
                    onLookupValueChange={this.props.onLookupValueChange} descriptionProp="LegalName" SecondDescriptionProp="TradeName"
                    history={this.props.history}
                    buttonClickHandler={this.handleToolbarButtonClick}
                    keyUpSwitch={this.state.keyUpSwitch} deleteUrl={"api/sims/provider/RemoveProvider"} useDeletePost={true}
                    promptTitle={"Remove Provider"} promptContent={"Are you sure you want to remove this provider?"}
                    setSelection={(selection) => { this.handleSelection(selection) }}
                >
                    <OnlineProviderApprovalSearchForm data={this.state.model} onKeyUp={(e) => { this.onkeyup(e) }}
                        valueChangeHandler={(values) => {
                            if (JSON.stringify(this.state.model) !== JSON.stringify(values)) {
                                this.setState({ model: values });
                            }
                        }} />
                </SearchView>
            </ViewContainer>
        );
    }
}


export default withRouter(withMenuPermission(OnlineProviderApprovalSearch));

